module.exports = __webpack_public_path__ + "static/media/brand-refresh-Profile.f0c150a9.svg";